
      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "INTERFACE",
        "name": "WWS_PageItem",
        "possibleTypes": [
          {
            "name": "WWS_AccommodationItem"
          },
          {
            "name": "WWS_ActivityItem"
          },
          {
            "name": "WWS_BasicItem"
          },
          {
            "name": "WWS_CoverPhotoItem"
          },
          {
            "name": "WWS_EmbedItem"
          },
          {
            "name": "WWS_GifItem"
          },
          {
            "name": "WWS_HeadlineItem"
          },
          {
            "name": "WWS_LivestreamItem"
          },
          {
            "name": "WWS_ParagraphItem"
          },
          {
            "name": "WWS_PersonItem"
          },
          {
            "name": "WWS_PhotoGalleryItem"
          },
          {
            "name": "WWS_PhotoItem"
          },
          {
            "name": "WWS_PhotoTimelineItem"
          },
          {
            "name": "WWS_QuestionItem"
          },
          {
            "name": "WWS_StoryItem"
          },
          {
            "name": "WWS_TransportationItem"
          },
          {
            "name": "WWS_DressCodeItem"
          },
          {
            "name": "WWS_EventGroupItem"
          },
          {
            "name": "WWS_GroupItem"
          },
          {
            "name": "WWS_WeddingPartyItem"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "WWS_SectionContent",
        "possibleTypes": [
          {
            "name": "WWS_SectionItem"
          },
          {
            "name": "WWS_Story"
          },
          {
            "name": "WWS_ContentItem"
          },
          {
            "name": "WWS_LocationContent"
          },
          {
            "name": "WWS_PhotoAlbum"
          }
        ]
      }
    ]
  }
};
      export default result;
    